export const committees = ['C00573261', 'C00646646', 'C00341271', 'C00492785'];
